(function () {
  // October 2026 "Build Your Routine" campaign — Recharge injects its own
  // "One-time purchase / Subscribe & Save" widget async (~5s after page load).
  // This watches for its one-time price element and overlays our sale price,
  // without touching the Subscribe & Save price (separate Recharge discount).
  var dataEl = document.getElementById('oct-tier-data');
  if (!dataEl) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!data.pct || !data.original_price_cents) return;

  var afterCents = data.original_price_cents - Math.round(data.original_price_cents * data.pct / 100);

  function money(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  var isApplying = false;

  function applySale(el) {
    if (!el || isApplying) return;
    isApplying = true;

    var target = money(afterCents);
    if (el.textContent !== target) {
      el.textContent = target;
      el.style.fontWeight = '700';
    }

    var wrapper = el.parentElement;
    if (!wrapper || !wrapper.classList || !wrapper.classList.contains('oct-rc-wrap')) {
      wrapper = document.createElement('span');
      wrapper.className = 'oct-rc-wrap';
      wrapper.style.display = 'inline-flex';
      wrapper.style.alignItems = 'baseline';
      wrapper.style.gap = '8px';
      el.parentNode.insertBefore(wrapper, el);

      var compare = document.createElement('span');
      compare.className = 'oct-rc-compare';
      compare.textContent = money(data.original_price_cents);
      compare.style.textDecoration = 'line-through';
      compare.style.opacity = '0.5';
      compare.style.fontWeight = '400';
      wrapper.appendChild(compare);
      wrapper.appendChild(el);
    }

    isApplying = false;
  }

  function scan() {
    var el = document.querySelector('[data-price-onetime]');
    if (el) applySale(el);
  }

  scan();

  var observer = new MutationObserver(scan);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });

  // Belt-and-suspenders: also poll directly in case Recharge updates the
  // price in a way that doesn't surface as an observable mutation.
  var pollInterval = setInterval(scan, 500);

  // Recharge's widget injects within a few seconds of load — stop watching
  // well after that to avoid running indefinitely.
  setTimeout(function () {
    observer.disconnect();
    clearInterval(pollInterval);
  }, 20000);
})();
